__webpack_require__.p = "/vestniky-fe/";